export const MSB_ROLE = {
  None: 0,
  Limited: 1,
  Employee: 2,
  Admin: 3,
  SuperAdmin: 4,
} as const;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type HasMsbRole = Record<string, any> & {
  msbRole?: number | null;
  isMsbAdmin?: boolean;
  isSuperAdmin?: boolean;
};

/**
 * Resolves the effective msbRole from either the new numeric field or the old
 * boolean flags (isMsbAdmin / isSuperAdmin) present on the profile-sdk UserResponse.
 */
const effectiveRole = (user?: HasMsbRole | null): number => {
  if (user?.msbRole != null) return user.msbRole;
  if (user?.isSuperAdmin) return MSB_ROLE.SuperAdmin;
  if (user?.isMsbAdmin) return MSB_ROLE.Admin;
  return MSB_ROLE.None;
};

export const isAnyMsb = (user?: HasMsbRole | null) => effectiveRole(user) > MSB_ROLE.None;
export const isAtLeastEmployee = (user?: HasMsbRole | null) =>
  effectiveRole(user) >= MSB_ROLE.Employee;
export const isAtLeastAdmin = (user?: HasMsbRole | null) =>
  effectiveRole(user) >= MSB_ROLE.Admin;
export const isSuperAdmin = (user?: HasMsbRole | null) =>
  effectiveRole(user) >= MSB_ROLE.SuperAdmin;
